module.exports = __webpack_public_path__ + "img/securecode.ff027b08.png";